// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.feedclaim.enums.RentalManagerUserFeedClaimRequestType

export enum RentalManagerUserFeedClaimRequestType {
  ADD_INACTIVE_LISTING = 'ADD_INACTIVE_LISTING',
  ADD_NEW_FEED = 'ADD_NEW_FEED',
  ADD_NEW_LISTING = 'ADD_NEW_LISTING',
  OTHER = 'OTHER',
  SWITCH_FEED = 'SWITCH_FEED',
}

export const RentalManagerUserFeedClaimRequestType_values = [
  RentalManagerUserFeedClaimRequestType.ADD_INACTIVE_LISTING,
  RentalManagerUserFeedClaimRequestType.ADD_NEW_FEED,
  RentalManagerUserFeedClaimRequestType.ADD_NEW_LISTING,
  RentalManagerUserFeedClaimRequestType.OTHER,
  RentalManagerUserFeedClaimRequestType.SWITCH_FEED,
] as const;
